import { addSeconds } from "./date";
import { uuidv4 } from "./util";

const WINDOWLIST_KEY = "ST_SESSION_SHARED_WindowManager_windowList";
window.name = window.name || uuidv4();
const instanceId = uuidv4();

class WindowDetails {
    windowName: string
    instance: string
    heartbeat: number

    constructor() {
        this.windowName = window.name;
        this.instance = instanceId;
        this.heartbeat = new Date().getTime();
    }
}

// createSharedStore has some issues to iron out.  For now, we'll just use localStorage directly.
//const [windowList, setWindowList] = createSharedStore<WindowDetails[]>(WINDOWLIST_KEY, []);
function windowList(): WindowDetails[] {
    return JSON.parse(localStorage[WINDOWLIST_KEY] || '[]');
}

function setWindowList(winList: WindowDetails[]) {
    localStorage[WINDOWLIST_KEY] = JSON.stringify(winList);
}

// Ensure the window list stays current
function updateWindowList() {
    const expiration = addSeconds(new Date(), -30).getTime();
    const validWindows = windowList().filter(w => w.heartbeat > expiration && w.instance !== instanceId);
    setWindowList([...validWindows, new WindowDetails()]);
}
setInterval(updateWindowList, 10000);
updateWindowList();

export function windowInfo() {
    return new WindowDetails();
}

let root: Window;
export function rootWindow() {
    if (!root) {
        root = window;
        let processedWindows: Window[] = [];

        while (!processedWindows.includes(root)) {
            processedWindows.push(root);
            try {
                const parent = root.top?.opener;
                if (parent && isValidWindow(parent.name)) {
                    root = parent;
                }
            }
            catch { }
        }
    }

    return root;
}

/**
 * Find a descendent window. This will not find sibling (root) windows
 * @param name the window.name property
 * @returns a reference to the target window
 */
export function findWindow(name: string): Window | undefined {
    if (name === window.name)
        return window;

    // Check if the window exists
    if (windowList().find(w => w.windowName === name)) {
        const res = window.open('', name, '') ?? undefined;

        if (res?.location.href === 'about:blank') {
            setWindowList(windowList().filter(w => w.windowName !== name));
            res.close();
        }
        else {
            return res;
        }
    }
}

/**
 * Verify a window is still open. This will also validate sibling (root) windows
 * @param name the window.name property
 * @returns
 */
export function isValidWindow(name: string, instanceId: string | undefined = undefined): boolean {
    return !!windowList().find(w => w.windowName === name && (!instanceId || w.instance == instanceId));
}

window.addEventListener('beforeunload', () => {
    setWindowList(
        windowList().filter(w => w.instance !== instanceId)
    );

    // Clear session variables if this is the last window open
    if (windowList().length === 0) {
        for (let key of Object.getOwnPropertyNames(localStorage)) {
            if (key.indexOf('ST_SESSION') === 0) {
                localStorage.removeItem(key);
            }
        }
    }
});
